import "./Banner.css"

import Icon from "@utilities/Icon"
import classnames from "classnames"
import React from "react"

type BannerProps = {
  /** The content to display in the banner */
  children: React.ReactNode

  /**
   * Set the size of the banner (adjusts padding)
   * @default "md"
   */
  size?: "sm" | "md"

  /**
   * Set the status of the banner
   * @default "neutral"
   */
  status?: "neutral" | "info" | "warning" | "error" | "success"

  /** Set the title of the banner */
  title?: string
}

const ICONS = {
  error: "general#exclamation-triangle",
  info: "general#info-circle",
  neutral: null,
  success: "general#check-circle",
  warning: "general#exclamation-triangle",
}

const SIZES = {
  md: "",
  sm: "t-banner--sm",
}

const STATUSES = {
  error: "t-banner--status-error",
  info: "t-banner--status-info",
  neutral: "t-banner--status-neutral",
  success: "t-banner--status-success",
  warning: "t-banner--status-warning",
}

export const Banner = ({
  children = "",
  size = "md",
  status = "neutral",
  title = "",
}: BannerProps) => {
  return (
    <div className={classnames("t-banner", SIZES[size], STATUSES[status])}>
      {ICONS[status] && (
        <span className="t-banner-icon">
          <Icon symbol={ICONS[status]} aria-hidden />
        </span>
      )}
      <div>
        {title && <span className="t-banner-title">{title}</span>}
        <div className="t-banner-body">{children}</div>
      </div>
    </div>
  )
}

export default Banner
